<template>
  <div class="manager_box" v-loading="loading">
    <div class="main" style="width: 100%">
      <div class="add_box">
        <div class="add">
          <el-button type="primary" @click="create" style="margin-right: 20px"
            >创建账号</el-button
          >
          <!-- <el-button type="primary" @click="">创建客服</el-button> -->
          <el-cascader
            class="elCasc"
            v-model="place_value"
            :options="place_options"
            placeholder="搜索代理商公司所在地"
            :props="agent_props"
            clearable
            v-if="is_agentData == '24猎代理商'"
            @change="cityChange"
          ></el-cascader>
          <el-dialog
            :title="title_name"
            :visible.sync="dialogFormVisible"
            class="el_table_class"
            :before-close="
              () => {
                is_agent_bianji = false;
                is_dailiShange = false;
                dialogFormVisible = false;
              }
            "
            @close="closeClick"
          >
            <el-form :model="form" ref="ruleForm" :rules="rules">
              <el-form-item
                label="用户帐号"
                prop="username"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.username"
                  type="number"
                  oninput="if(value.length>5)value=value.slice(0,11)"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写用户帐号"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="!judge_button"
                label="用户密码"
                prop="password"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.password"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写用户密码"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="真实姓名"
                prop="realname"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.realname"
                  autocomplete="off"
                  placeholder="请输入真实姓名"
                  style="width: 90%"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="手机号"
                prop="mobile"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.mobile"
                  type="number"
                  oninput="if(value.length>5)value=value.slice(0,11)"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写手机号"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="性别"
                prop="gender"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-select
                  v-model="form.gender"
                  placeholder="请选择性别"
                  style="width: 90%"
                >
                  <el-option
                    v-for="(item, index) in sex"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="$cookies.get('auth_grade') == 100"
                label="权限"
                prop="auth_id"
                :label-width="formLabelWidth"
                class="el_input_width"
                :required="true"
              >
                <el-select
                  v-model="form.auth_id"
                  style="width: 90%"
                  placeholder="请选择权限"
                  @change="select_auth"
                >
                  <el-option
                    v-for="(item, index) in auth_list"
                    :key="index"
                    :label="item.character_name"
                    :value="item.auth_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="
                  $cookies.get('auth_grade') <= 80 &&
                  $cookies.get('agent_company_name') !== null
                "
                label="职位"
                :label-width="formLabelWidth"
                style="width: 90%"
                :required="true"
              >
                <el-select
                  v-model="form.agent_position"
                  :disabled="
                    $cookies.get('auth_grade') == 80 &&
                    form.agent_position == '公司超级管理员'
                  "
                  placeholder="请选择职位"
                >
                  <el-option
                    v-for="item in position_options"
                    :key="item.value"
                    :label="item.agent_position"
                    :value="item.agent_position"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="is_shengDai && $cookies.get('auth_grade') == 100"
                label="所属代理商"
                :label-width="formLabelWidth"
                style="width: 90%"
              >
                <el-cascader
                  :options="SagentData"
                  v-model="parent_agent_id"
                ></el-cascader>
              </el-form-item>
              <el-form-item
                v-if="
                  is_zhiwei &&
                  $cookies.get('auth_grade') <= 80 &&
                  $cookies.get('agent_company_name') !== null
                "
                label="所属上级"
                :label-width="formLabelWidth"
                style="width: 90%"
                :required="true"
              >
                <el-cascader
                  :options="agentData"
                  :props="{
                    value: 'staff_id',
                    label: 'name',
                    children: 'staff',
                  }"
                  v-model="form.agent_superiors_id"
                ></el-cascader>
              </el-form-item>
              <el-form-item
                v-if="is_dailiShange && $cookies.get('auth_grade') == 100"
                label="公司名称"
                :label-width="formLabelWidth"
                style="width: 90%"
                prop="agent_company_name"
              >
                <el-input
                  placeholder="请输入公司名称"
                  style="width: 100%"
                  v-model="form.agent_company_name"
                ></el-input>
              </el-form-item>
              <el-form-item
                v-if="
                  is_dailiShange &&
                  $cookies.get('auth_grade') == 100 &&
                  is_agent_bianji
                "
                label="代理商所属城市"
                :label-width="formLabelWidth"
                prop="agent_cityData"
                class="el_input_width"
              >
                <el-cascader
                  :options="city_data"
                  v-model="form.agent_cityData"
                ></el-cascader>
              </el-form-item>
              <el-form-item
                v-if="$cookies.get('auth_grade') == 100 && department_authority"
                label="所属部门"
                prop="product_name"
                :label-width="formLabelWidth"
                :required="true"
                class="el_input_width"
              >
                <el-select
                  @change="departmentC"
                  v-model="form.product_name"
                  style="width: 90%"
                  placeholder="请选择所属"
                >
                  <el-option
                    v-for="(item, index) in department"
                    :key="index"
                    :label="item.realname"
                    :value="item.staff_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="is_pro"
                label="所辖省代"
                prop="product_name"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-cascader
                  :props="proProps"
                  :options="provinceList"
                  v-model="sale_province_agent_staff_id"
                ></el-cascader>
              </el-form-item>
              <el-form-item
                v-if="is_pro"
                label="所辖代理商"
                prop="product_name"
                :label-width="formLabelWidth"
                class="el_input_width"
                @change="$forceUpdate()"
              >
                <el-select
                  v-model="sale_agent_staff_id"
                  style="width: 90%"
                  placeholder="所辖代理商"
                  filterable
                  multiple
                >
                  <el-option
                    v-for="(item, index) in agent_list"
                    :key="index"
                    :label="item.agent_company_name"
                    :value="item.staff_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item
                label="所属上级"
                :label-width="formLabelWidth"
                :required="true"
                class="el_input_width"
              >
                <el-select
                  v-model="form.product_name"
                  style="width:90%;"
                  placeholder="请选择所属上级"
                >
                  <el-option
                    v-for="(item, index) in department"
                    :key="index"
                    :label="item.realname"
                    :value="item.staff_id"
                  ></el-option>
                </el-select>
              </el-form-item>-->
            </el-form>
            <div
              slot="footer"
              class="dialog-footer"
              :class="[judge_button ? 'flex_button_div' : 'flex_button_div01']"
            >
              <el-button type="promary" @click="chpwd" v-if="judge_button"
                >修改密码</el-button
              >
              <div class="felx_primary">
                <el-button type="primary" @click="cancel()">取 消</el-button>
                <el-button type="primary" @click="addPro('ruleForm')"
                  >确 定</el-button
                >
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
      <el-dialog
        title="修改密码"
        :visible.sync="dialogFormVisible1"
        class="el_table_class"
      >
        <el-form :model="form" class="demo-ruleForm" ref="ruleForm1">
          <el-form-item
            label="修改的密码"
            :label-width="formLabelWidth"
            class="el_input_width"
          >
            <el-input
              v-model="form1.password"
              autocomplete="off"
              style="width: 90%"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancel1()">取 消</el-button>
          <el-button type="primary" @click="reduce('ruleForm1')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- <el-button type="promary" @click="redact_item(scope.row.staff_id)">编辑</el-button> -->
      <div class="el_tree" v-if="auth_grade_number">
        <div class="shuzhuang">
          <div
            :class="{ active: Tree_data_value == item.staff_id }"
            v-for="item in Tree_data"
            :key="item.staff_id"
            @click="handleNodeClick(item)"
          >
            {{ item.realname }}
          </div>
        </div>
        <div
          style="
            flex: 1;
            min-height: 80vh;
            background: white;
            overflow: auto;
            padding: 20px;
          "
          v-loading="loading1"
        >
          <el-table
            :data="tableData"
            :stripe="true"
            ref="multipleTable"
            tooltip-effect="dark"
          >
            <!-- <el-table-column type="selection"></el-table-column> -->
            <el-table-column prop="realname" label="姓名" min-width="80">
              <template slot-scope="scope">
                <div
                  :title="scope.row.realname"
                  :class="scope.row.realname.length > 4 ? 'color' : ''"
                >
                  {{
                    scope.row.realname.length > 4
                      ? scope.row.realname.substring(0, 4) + "..."
                      : scope.row.realname
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="性别" show-overflow-tooltip min-width="60">
              <template slot-scope="scope">
                {{ scope.row.gender == 1 ? "男" : "女" }}
              </template>
            </el-table-column>
            <el-table-column
              prop="mobile"
              label="手机号"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="username"
              label="帐号"
              min-width="120"
            ></el-table-column>
            <el-table-column
              v-if="is_company_name"
              label="公司名称"
              prop="agent_company_name"
              min-width="120"
            >
              <template slot-scope="scope">
                <div
                  :title="scope.row.agent_company_name"
                  :class="
                    scope.row.agent_company_name.length > 4 ? 'color' : ''
                  "
                >
                  {{
                    scope.row.agent_company_name.length > 4
                      ? scope.row.agent_company_name.substring(0, 4) + "..."
                      : scope.row.agent_company_name
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="所属部门"
              prop="product_name"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="角色"
              prop="auth_name"
              min-width="120"
            ></el-table-column>
            <el-table-column
              v-if="is_company_name"
              label="所属城市"
              min-width="120"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.agent_city_data">
                  {{ scope.row.agent_city_data.province_name }}-
                  {{ scope.row.agent_city_data.city_name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              show-overflow-tooltip
              min-width="120"
            >
              <template slot-scope="scope">
                {{ scope.row.create_time }}
              </template>
            </el-table-column>
            <el-table-column min-width="150" label="操作">
              <template slot-scope="scope">
                <el-button type="promary" @click="edit(scope.row)"
                  >修改</el-button
                >
                <el-button type="danger" @click="deal_item(scope.row.staff_id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-table
        v-else
        :data="tableData"
        :stripe="true"
        ref="multipleTable"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column prop="realname" label="姓名" min-width="80">
          <template slot-scope="scope">
            <div
              :title="scope.row.realname"
              :class="scope.row.realname.length > 4 ? 'color' : ''"
            >
              {{
                scope.row.realname.length > 4
                  ? scope.row.realname.substring(0, 4) + "..."
                  : scope.row.realname
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="性别" show-overflow-tooltip min-width="50">
          <template slot-scope="scope">
            {{ scope.row.gender == 1 ? "男" : "女" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="帐号"
          min-width="120"
        ></el-table-column>
        <el-table-column
          label="所属部门"
          prop="product_name"
          min-width="120"
        ></el-table-column>
        <el-table-column
          label="职位"
          prop="agent_position"
          min-width="120"
        ></el-table-column>
        <el-table-column
          label="角色"
          prop="auth_name"
          min-width="120"
        ></el-table-column>
        <el-table-column label="创建时间" show-overflow-tooltip min-width="120">
          <template slot-scope="scope">{{ scope.row.create_time }}</template>
        </el-table-column>
        <el-table-column min-width="150" label="操作">
          <template slot-scope="scope">
            <el-button type="promary" @click="edit(scope.row)">修改</el-button>
            <el-button type="danger" @click="deal_item(scope.row.staff_id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          :current-page="currentPage"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { require } from "@/utils/http_request.js";

export default {
  data() {
    return {
      position_options: [],
      auth_grade_number: false,
      Tree_data: [],
      defaultProps: {
        children: "children",
        label: "realname",
      },
      Tree_data_value: "超级管理员",
      row_edit: {},
      title_name: "创建账号",
      judge_button: false,
      department: [
        {
          realname: "24猎",
          staff_id: "24猎",
        },
        {
          realname: "劳务巴士",
          staff_id: "劳务巴士",
        },
        {
          realname: "渠道",
          staff_id: "渠道",
        },
      ],
      auth_grade: 0,
      sex: [
        {
          label: "男",
          value: 1,
        },
        {
          label: "女",
          value: 2,
        },
      ],
      auth_list: [],
      dialog: false,
      visible: false,
      tableData: [],
      form: {
        username: "",
        password: "",
        mobile: "",
        gender: "",
        realname: "",
        auth_id: "",
        product_name: "",
      }, //表单数据
      form1: {
        password: "",
      }, //表单数据
      rules: {
        username: [
          { required: true, message: "请输入用户账号", trigger: "blur" },
          {
            min: 1,
            max: 11,
            message: "长度在 1 到 11 个字符",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 1, max: 11, message: "请输入正确的手机号", trigger: "blur" },
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        auth_id: [{ required: true, message: "请选择权限", trigger: "change" }],
        realname: [
          { required: true, message: "请输入真实姓名", trigger: "blur" },
        ],
        agent_company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        agent_cityData: [
          { required: true, message: "请选择城市", trigger: "change" },
        ],
        agent_position: [
          { required: true, message: "请选择职位", trigger: "change" },
        ],
      },
      multipleSelection: [],
      dialogFormVisible: false, //创建弹框
      dialogFormVisible1: false, //创建弹框
      formLabelWidth: "120px",
      search_data: {},
      change_id: "",
      department_authority: false,
      is_dailiShange: false, //创建窗口权限下拉出现代理商时显示的输入框，
      is_shengDai: false, //创建窗口权限下拉出现代理商时显示的输入框，
      is_company_name: false, //列表是否显示公司名称 当左侧选取代理商时,
      agentData: [],
      is_zhiwei: true,
      is_agent_bianji: true,
      is_agentData: "超级管理员",
      loading: true,
      SagentData: [], //代理商列表（省代权限）
      page: 0,
      total: 0,
      currentPage: 1,
      loading1: true,
      parent_agent_id: "",
      provinceList: [], //所辖省代选择列表
      agent_list: [], //所辖代理商选择列表
      is_pro: false,
      proProps: { multiple: true },
      sale_agent_staff_id: [],
      sale_province_agent_staff_id: [],
      place_value: [],
      place_options: [],
      agent_props: {
        label: "name",
        value: "id",
        children: "children",
      },
    };
  },
  methods: {
    // 弹出框关闭校验bug
    closeClick() {
      console.log(1);
      this.$refs.ruleForm.resetFields();
    },
    //代理商筛选
    cityChange(val) {
      console.log("asbjckbasjcbasjkbc");
      console.log(val);
      this.search();
    },
    //获取代理商地区列表
    agent_place() {
      require("post", "/lufish_user/v1/all_agent_city/", {}).then((res) => {
        this.place_options = res.data;
      });
    },
    departmentC(e) {
      if (e == "渠道" || e == "客服") {
        this.is_pro = true;
        return false;
      }
      this.is_pro = false;
      // console.log("ccasssssssss", e);
    },
    //分页
    currentChange(page) {
      this.currentPage = page;
      this.page = page - 1;
      this.search();
    },
    handleNodeClick(data) {
      console.log(data);
      this.is_pro = false;
      if (data.realname == "24猎代理商") {
        // console.log("ascvghhvvvghjkhhhhhhhhhhhhhkhkhhhhhhhhhhhhhhhhhhhhhhh");
        this.is_company_name = true;
      } else {
        this.is_company_name = false;
      }
      this.is_agentData = data.realname;
      this.Tree_data_value = data.staff_id;
      this.page = 0;
      this.currentPage = 0;
      // return false
      this.search();
    },
    search(e) {
      this.loading1 = true;
      this.agentList(); //获取所属上级列表
      this.all_province_agent_list();
      let obj = {
        page: this.page,
      };
      if (this.place_value.length > 0) {
        obj.city_id = this.place_value[1];
      }
      // obj["page"] = this.currentPage;
      require("post", "/lufish_user/v1/lufish_staff_list/", obj).then((res) => {
        console.log("内容", res);
        if (!res.code) {
          let addi = [];
          let add = [];
          let tableData = [];
          let total = 0;
          let arr = []
          // console.log('-----------------------------------------is_agentData', this.is_agentData)
          if (this.$cookies.get("auth_grade") == 100) {
            console.log('-------------------------------')
            res.data.forEach((item, index) => {
              if (item.realname != "朱澄月") {
                addi.push(item);
                arr.push(item.realname);
              }
              if( item.realname != this.is_agentData ){
                tableData = item.value
                total = item.user_count
              }
            });
            // console.log("aaaaa", addi, add, tableData, total);
            // let arr = ["超级管理员", "客服", "渠道", "劳务巴士", "24猎代理商"];
            arr.forEach((item) => {
              addi.forEach((res) => {
                if (res.realname == item) {
                  add.push(res);
                }
              });
            });
            console.log(add,'add');
            this.Tree_data = add;
            this.department = add;
            // console.log("add", add, add[0].user_count);
            // if (e) {
            //   this.Tree_data_value = add[0].staff_id
            //   this.total = add[0].user_count
            // }
            // if (this.$cookies.get("agent_company_name") == null) {
            //   if (this.is_agentData != "") {
            //     this.is_company_name = true;
            //   } else {
            //     this.is_company_name = false;
            //   }
            // }
            let index = arr.indexOf(this.is_agentData);
            // console.log("is_agentData", this.is_agentData, index, addi);
            this.tableData = add[index == -1 ? 0 : index].value;
            this.total = add[index == -1 ? 0 : index].user_count;
            // console.log(this.tableData[0]);
          } else {
            this.tableData = res.data;
            this.total = res.user_count;
          }
          this.loading = false;
          this.loading1 = false;
        }
      });
      // require("post", "/lufish_user/v1/lufish_user_list/", obj).then(res => {
      //   if (!res.code) {
      //     this.tableData = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });
    },
    authList() {
      require("post", "/lufish_user/v1/user_authority/", {}).then((res) => {
        if (!res.code) {
          this.auth_list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 编辑
    edit(row) {
      console.log("行信息", row);
      this.row_edit = row;
      this.title_name = "修改信息";
      this.judge_button = true;
      if (row.auth_id != "AUBJSMKKJ1") {
        this.department_authority = true;
      }
      // bug修改
      // else{
      //   this.department_authority=false
      // }
      if (row.auth_id == "AUBJSMKKJ5" || row.auth_id == "AUBJSMKKJ6") {
        this.department_authority = false;
        this.is_dailiShange = true;
        this.is_agent_bianji = true;
      } else {
        this.is_agent_bianji = false;
        this.is_dailiShange = false;
      }
      if (row.auth_id == "AUBJSMKKJ5") {
        this.is_shengDai = true;
      } else {
        this.is_shengDai = false;
      }
      if (this.$cookies.get("agent_company_name") != null) {
        console.log(11, this.$cookies.get("agent_position"));
        if (this.$cookies.get("agent_position") == row.agent_position) {
          this.is_zhiwei = false;
          console.log(
            this.$cookies.get("agent_position") == row.agent_position
          );
        } else {
          this.is_zhiwei = true;
        }
      }
      this.form = {
        username: row.username,
        mobile: row.mobile,
        gender: row.gender,
        realname: row.realname,
        auth_id: row.auth_id,
        product_name: row.product_name,
        agent_company_name: row.agent_company_name,
        agent_superiors_id: ["", row.agent_superiors_id],
        agent_position: row.agent_position,
      };
      if (row.is_customer_service) {
      }
      this.parent_agent_id = row.province_agent_id;
      if (this.is_company_name) {
        console.log(row.agent_city_data);
        if (JSON.stringify(this.form.agent_cityData) != "{}") {
          console.log("aaa");
          this.form.agent_cityData = [
            row.agent_city_data.province_code || "",
            row.agent_city_data.city_code || "",
          ];
        } else {
          this.form.agent_cityData = [];
        }
      }
      this.change_id = row.staff_id;
      if (
        (this.form.product_name == "渠道" ||
          this.form.product_name == "客服") &&
        this.$cookies.get("auth_grade") == 100
      ) {
        this.is_pro = true;
        this.sale_province_agent_staff_id = row.sale_province_agent_staff_info;
        console.log(row.sale_province_agent_staff_info);
        if (row.sale_agent_staff_id.split(",")[0] == "") {
          this.sale_agent_staff_id = "";
        } else {
          this.sale_agent_staff_id = JSON.parse(
            JSON.stringify(row.sale_agent_staff_id.split(","))
          );
        }
        console.log(
          this.sale_agent_staff_id,
          "  this.form.sale_agent_staff_id "
        );
      }

      this.dialogFormVisible = true;
    },
    // 修改密码
    chpwd() {
      this.form1.password = "";
      this.dialogFormVisible1 = true;
    },
    reduce() {
      let obj = this.form1;
      obj["staff_id"] = this.change_id;
      require("post", "/lufish_user/v1/lufish_update_password/", obj).then(
        (res) => {
          if (!res.code) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.dialogFormVisible1 = false;
            this.dialogFormVisible = false;
            this.search();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    // 删除
    deal_item(id) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let obj = { label_code: "del_user", staff_id: id };
          require("post", "/lufish_user/v1/lufish_user/", obj).then((res) => {
            if (!res.code) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.search();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    pageSizeChange(e) {
      console.log(e);
    },
    current_change(e) {
      this.currentPage = e - 1;
      this.cilent_Page = e;
      this.search();
    },
    create() {
      this.is_zhiwei = true;
      this.form = {
        username: "",
        password: "",
        mobile: "",
        gender: "",
        realname: "",
        auth_id: "",
        product_name: "",
        agent_superiors_id: [],
      };
      this.title_name = "创建账号";
      this.judge_button = false;
      this.dialogFormVisible = true;

      // bug修改
      this.is_pro = false;
      this.department_authority = false;
      this.is_shengDai = false;
      this.is_dailiShange = false;
      this.$refs.ruleForm.resetFields();
    },
    cancel() {
      this.form = {};
      delete this.form.agent_cityData;
      this.is_agent_bianji = false;
      this.is_agent_bianji = false;
      this.dialogFormVisible = false;
    },
    cancel1() {
      this.dialogFormVisible1 = false;
    },
    //添加客户
    addPro(formName) {
      if (!this.judge_button) {
        //创建
        let form = this.form;
        // agent_company_name不等于空
        if (this.$cookies.get("agent_company_name") != null) {
          if (this.$cookies.get("auth_grade") < 80) {
            form.agent_company_name = this.$cookies.get("agent_company_name");
          }

          console.log("this.form.agent_position", this.form.agent_position);

          if (this.form.agent_position.length > 0) {
            if (this.form.agent_superiors_id) {
              form.agent_superiors_id =
                this.form.agent_superiors_id[
                  this.form.agent_superiors_id.length - 1
                ];
            }
            form.product_name = "24猎代理商";

            if (
              this.form.agent_position == "职员" ||
              this.form.agent_position == "员工"
            ) {
              form.auth_id = "AUBJSMKKJ3";
            } else if (this.form.agent_position == "客服") {
              form.auth_id = "AUBJSMKKJ7";
            } else {
              form.auth_id = "AUBJSMKKJ2";
            }
          }
        } else {
          delete form.agent_superiors_id;
          if (this.$cookies.get("auth_grade") < 80) {
            form.auth_id = "AUBJSMKKJ3";
          }
          if (this.form.agent_cityData) {
            if (this.form.agent_cityData.length > 0) {
              form.agent_province_id = this.form.agent_cityData[0];
              form.agent_city_id =
                this.form.agent_cityData[this.form.agent_cityData.length - 1];
              console.log("进入啊啊啊");
              delete form.agent_cityData;
              console.log("进入啊啊啊", form);
            }
          }
          console.log(this.parent_agent_id);
          if (this.form.auth_id == "AUBJSMKKJ5") {
            if (typeof this.parent_agent_id == "string") {
              form.parent_agent_id = this.parent_agent_id;
            } else {
              form.parent_agent_id = this.parent_agent_id[1] || "";
            }
            console.log(this.parent_agent_id, "this.parent_agent_id");
          }
        }
        // for (let i in this.rules) {
        //   if (form[i] == "") {
        //     console.log(form[i]);
        //     this.$message.error("请检查数据格式");
        //     return;
        //   }
        // }
        // 当选AUBJSMKKJ6添加一个is_province_agent为1
        if (this.form.auth_id == "AUBJSMKKJ6") {
          form.is_province_agent = 1;
        }
        // if (this.form.auth_id == "AUBJSMKKJ7") {
        //   form.auth_id = "AUBJSMKKJ3";
        //   form.is_customer_service = 1;
        // }
        console.log(
          form.sale_province_agent_staff_id,
          form.sale_agent_staff_id
        );
        // if (
        //   this.is_pro &&
        //   (!this.sale_province_agent_staff_id || !this.sale_agent_staff_id)
        // ) {
        //   this.$message.warning("请选择所辖代理商");
        //   return false;
        // }
        if (
          this.sale_province_agent_staff_id &&
          typeof this.sale_province_agent_staff_id == "object"
        ) {
          let arrStr = [];
          this.sale_province_agent_staff_id.forEach((item) => {
            arrStr.push(item[1]);
          });
          form.sale_province_agent_staff_id = arrStr.toString();
        }
        if (
          this.sale_agent_staff_id &&
          typeof this.sale_agent_staff_id == "object"
        ) {
          let arrStr = [];
          this.sale_agent_staff_id.forEach((item) => {
            arrStr.push(item);
          });
          form.sale_agent_staff_id = arrStr.toString();
        }

        let obj = form;
        // 创建的时候添加一个label_code字段为create_user,证明他是创建
        obj["label_code"] = "create_user";
        console.log(obj);
        require("post", "/lufish_user/v1/lufish_user/", obj).then((res) => {
          if (!res.code) {
            this.dialogFormVisible = false;
            this.agent_cityData = [];
            this.is_agent_bianji = false;
            this.is_dailiShange = false;
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.page = 0;
            this.currentPage = 1;
            this.sale_agent_staff_id = [];
            this.sale_province_agent_staff_id = [];
            this.search();
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        let form = this.form;
        if (this.$cookies.get("agent_company_name") != null) {
          console.log("职位");
          if (form.agent_position.length > 0) {
            if (form.agent_superiors_id) {
              form.agent_superiors_id =
                form.agent_superiors_id[form.agent_superiors_id.length - 1] ||
                "";
            }
            form.product_name = "24猎代理商";
            if (
              form.agent_position == "职员" ||
              form.agent_position == "员工"
            ) {
              form.auth_id = "AUBJSMKKJ3";
            } else if (this.form.agent_position == "客服") {
              form.auth_id = "AUBJSMKKJ7";
            } else {
              form.auth_id = "AUBJSMKKJ2";
            }
            if (form.agent_position == "公司超级管理员") {
              form.auth_id = "AUBJSMKKJ5";
            }
          }
        } else {
          if (this.is_company_name) {
            delete form.agent_superiors_id;
            if (form.agent_cityData.length > 0) {
              console.log("代理商所属城市", form);
              form.agent_province_id =
                form.agent_cityData[form.agent_cityData.length - 2];
              form.agent_city_id =
                form.agent_cityData[form.agent_cityData.length - 1];
              console.log("进入啊啊啊");
              delete form.agent_cityData;
              console.log("进入啊啊啊", form);
            }
          } else {
            if (this.$cookies.get("auth_grade") >= 80) {
              delete form.agent_superiors_id;
            }
          }
          if (this.form.auth_id == "AUBJSMKKJ5") {
            if (typeof this.parent_agent_id == "string") {
              form.parent_agent_id = this.parent_agent_id;
            } else {
              form.parent_agent_id = this.parent_agent_id[1] || "";
            }
            console.log(this.parent_agent_id);
          }
        }
        console.log(
          form.sale_province_agent_staff_id,
          form.sale_agent_staff_id
        );
        console.log("is_pro", this.is_pro);
        if (
          this.is_pro &&
          (!this.sale_province_agent_staff_id || !this.sale_agent_staff_id) &&
          this.form.auth_id != "AUBJSMKKJ7"
        ) {
        }
        if (
          this.sale_province_agent_staff_id &&
          typeof this.sale_province_agent_staff_id == "object"
        ) {
          let arrStr = [];
          this.sale_province_agent_staff_id.forEach((item) => {
            arrStr.push(item[1]);
          });
          form.sale_province_agent_staff_id = arrStr.toString();
        }
        if (
          this.sale_agent_staff_id &&
          typeof this.sale_agent_staff_id == "object"
        ) {
          let arrStr = [];
          this.sale_agent_staff_id.forEach((item) => {
            arrStr.push(item);
          });
          form.sale_agent_staff_id = arrStr.toString();
        }
        console.log(this.form.agent_cityData, "所属得历史");
        if (form.agent_cityData) {
          delete form.agent_cityData;
          console.log("进入啊啊啊", form);
        }
        let obj = {};
        obj.label_code = "update_user";
        obj.staff_id = this.change_id;
        if (this.form.auth_id == "AUBJSMKKJ6") {
          form.is_province_agent = 1;
        }
        obj.update_data = form;
        console.log("修改", obj);
        require("post", "/lufish_user/v1/lufish_user/", obj).then((res) => {
          if (!res.code) {
            this.search();
            this.dialogFormVisible = false;
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.agentList(); //获取所属上级列表
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    select_auth(e) {
      console.log(e);
      if (e == "AUBJSMKKJ1") {
        this.is_agent_bianji = false;
        this.is_dailiShange = false;
        console.log(111);
        this.department_authority = false;
      } else if (e == "AUBJSMKKJ5" || e == "AUBJSMKKJ6") {
        console.log("代理商额");
        this.is_dailiShange = true;
        this.form.product_name = "24猎代理商";
        this.department_authority = false;
        this.is_agent_bianji = true;
      } else {
        this.is_agent_bianji = false;
        console.log(222);
        this.is_shengDai = false;
        this.is_dailiShange = false;
        this.department_authority = true;
      }
      if (e == "AUBJSMKKJ5") {
        this.is_shengDai = true;
      } else {
        this.is_shengDai = false;
      }
    },
    agentList() {
      require("post", "/lufish_user/v1/company_position_staff_list/", {}).then(
        (res) => {
          if (!res.code) {
            console.log(res.data);
            this.agentData = res.data;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    get_agent_city_data() {
      require("post", "/commonality/v1/show_agent_place/", {}).then((res) => {
        if (!res.code) {
          console.log(res.data);
          this.city_data = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    all_province_agent_list() {
      require("post", "/lufish_user/v1/all_province_agent_list/", {}).then(
        (res) => {
          console.log(res);
          if (!res.code) {
            this.SagentData = res.data;
          }
        }
      );
      require("post", "/lufish_user/v1/all_province_agent_staff_list/", {}).then(
        (res) => {
          console.log(res);
          if (!res.code) {
            this.provinceList = res.data;
          }
        }
      );
      require("post", "/lufish_user/v1/all_agent_staff_list/", {}).then(
        (res) => {
          console.log(res);
          if (res.code == 0) {
            this.agent_list = res.data;
          }
        }
      );
    },
    agent_position_list() {
      require("post", "/lufish_user/v1/position_list/", {}).then((res) => {
        if (!res.code) {
          console.log(res.data);
          this.position_options = res.data;
        }
      });
    },
  },
  created() {
    console.log(this.$cookies.get("agent_company_name") == null);
    if (this.$cookies.get("auth_grade") == 100) {
      this.auth_grade_number = true;
    } else {
      this.auth_grade_number = false;
    }
    if (this.$cookies.get("agent_company_name") != null) {
      this.agent_position_list();
    }
    this.auth_grade = this.$cookies.get("auth_grade");
    this.search();
    this.authList();
    this.agentList(); //获取所属上级列表
    this.get_agent_city_data(); //获取所属上级列表
    this.all_province_agent_list();
    this.agent_place();
  },
  mounted() {},
};
</script>
<style scoped>
.main {
  padding-bottom: 70px;
  margin: 10px 0px;
  background: #ffff;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(32, 32, 32, 0.08);
  /* min-height: 80vh; */
  position: relative;
}
.add_box {
  height: 68px;
  box-sizing: border-box;
  background: #f5f5f5;
}
.add {
  background: white;
  padding: 20px;
}
.add .el-input {
  width: 50%;
}
/* 上传头像 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.filter_box {
  display: flex;
  width: calc(100% - 181px);
  border-bottom: 1px solid #e4e9ed;
  background: #fff;
  padding: 12px 24px;
  box-sizing: border-box;
  align-items: center;
}
.block {
  flex-grow: 1;
  margin-left: 20px;
}
.detail_info,
.detail_info > div,
.nav_left,
.nav_right,
.rl_flex {
  height: 100%;
}
.nav_title {
  padding: 16px 24px;
  border-bottom: 1px solid #e4e9ed;
  display: flex;
}
.nav_title > div {
  margin-left: 12px;
}
.rl_flex {
  display: flex;
}
.nav_left {
  width: 684px;
  border-right: 1px solid #e4e9ed;
}
.nav_left > div {
  padding: 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e9ed;
}
.over_title {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: #333;
}
.half_fl {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.pagination {
  position: absolute;
  width: 100%;
  bottom: 10px;
  display: flex;
  justify-content: center;
}
.status_box {
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  border-radius: 16px;
  position: relative;
}
.status_iter {
  display: flex;
  justify-content: space-between;
}
.status_item {
  display: flex;
  justify-content: center;
}
.status_color {
  color: #3d76f7;
}
.cir.status_back,
.line_item.status_back {
  background: #3d76f7;
}
.cir_item {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
}
.cir_item img {
  height: 24px;
  width: 24px;
}
.cir:hover,
.status_item .title:hover {
  cursor: pointer;
}
.line_iter {
  margin-top: 10px;
  background: #f5f6fa;
  line-height: 32px;
  height: 32px;
  overflow: hidden;
  width: 100%;
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
}
.line_item {
  position: absolute;
  height: 10px;
  width: 140px;
  background: #e5e7ee;
  left: 23px;
  top: 10px;
}
.cir {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: #e5e7ee;
  color: #3d76f7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.half_fl .title {
  width: 92px;
}
.half_fl .cont {
  color: #333;
  width: 200px;
  height: 32px;
  line-height: 32px;
}
.half_fl > div {
  align-items: center;
  display: flex;
  width: 50%;
  margin-bottom: 16px;
  font-size: 14px;
  color: #999;
}
.nav_left > div:last-child {
  border-bottom: none;
}
.nav_right {
  width: calc(100% - 684px);
  padding: 16px;
  box-sizing: border-box;
  font-size: 14px;
}
.rec_box .item {
  margin-top: 24px;
  font-size: 14px;
  line-height: 22px;
}
.rec_box .item_flex {
  display: flex;
}
.com_name {
  color: #999;
  width: 35%;
}
.item_grow {
  flex-grow: 1;
}
.el_tree {
  background: #f5f5f5;
  display: flex;
  min-height: 80vh;
}
.shuzhuang {
  /* border:1px red solid; */
  min-width: 200px;
  margin-right: 20px;
  background: white;
}
.shuzhuang > div {
  width: 100%;
  background: #fff;
  line-height: 40px;
  text-align: center;
  /* border-bottom: #ccc solid 1px; */
  cursor: pointer;
}
.shuzhuang > .active {
  color: rgb(44, 44, 44);
  background: rgba(115, 181, 246, 0.3);
  font-weight: bold;
}
.flex_button_div {
  display: flex;
  justify-content: space-between;
}
.flex_button_div01 {
  display: flex;
  justify-content: flex-end;
}
.felx_primary {
  display: flex;
}
.color {
  color: #409eff;
  cursor: pointer;
}
.page {
  text-align: center;
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/accounts_m.vue